/*** IMPORTS FROM imports-loader ***/
var define = false;

/**
 * ########################################
 * Init Slick Slider
 * ########################################
 */
$('.slider-logos').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    dots: false,
    responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 567,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

